import type { TranslationStrings } from '@/types/i18n'

export const en: TranslationStrings = {
  // App
  appName: 'SatMas',
  appTagline: 'Amharic Text Search',

  // Header
  search: 'Search',
  searchPlaceholder: 'Search...',
  selectFileFirst: 'Select a file first',
  signIn: 'Sign in',
  connected: 'Connected',
  offline: 'Offline',

  // Sidebar
  files: 'Files',
  history: 'History',
  favorites: 'Favorites',
  settings: 'Settings',
  noFiles: 'No files',
  uploadFilesToSearch: 'Upload files to search',
  clickBookToLoad: 'Click a book to load it',
  noHistory: 'No history',
  recentSearchesAppearHere: 'Recent searches appear here',
  noFavorites: 'No favorites',
  starSearchesToSaveThem: 'Star searches to save them',
  selectFileToStart: 'Select a file to get started with searching.',
  readyToSearch: 'Ready to search',

  // Input Methods
  inputFiles: 'Files',
  inputPaste: 'Paste',
  inputUrl: 'URL',
  pasteTextHere: 'Paste Amharic text here...',
  enterUrlHere: 'Enter URL to fetch text from...',
  load: 'Load',
  fetch: 'Fetch',
  useThisText: 'Use This Text',
  useSelectedText: 'Use Selected Text',
  pastedText: 'Pasted Text',
  urlContent: 'URL Content',
  textTooShort: 'Text is too short (min 10 characters)',
  invalidUrl: 'Please enter a valid URL',
  selectInputMethod: 'Choose how to load text for searching',
  urlPreview: 'Preview from URL',
  selectSections: 'Select sections to include',
  selectAll: 'Select All',
  deselectAll: 'Deselect All',
  selectedCount: 'selected',
  noContentFound: 'No text content found at this URL',
  backToUrl: 'Back',
  viewAll: 'View All',
  view: 'View',
  close: 'Close',
  words: 'words',
  previous: 'Previous',
  next: 'Next',
  page: 'Page',

  // Search
  selectFileToBegin: 'Select a file to begin searching Amharic text',
  modes: 'Modes',
  match: 'Match',
  literal: 'Literal',
  position: 'Position',
  form: 'Form',
  numbers: 'Numbers',
  sentences: 'Sentences',
  exact: 'Exact',
  prefix: 'Prefix',
  suffix: 'Suffix',
  contains: 'Contains',
  change: 'Change',
  formPattern: 'Form Pattern',
  formPatternHint: '(0-9 for vowel forms)',
  numberType: 'Number Type',
  digits: 'Digits',
  written: 'Written',
  both: 'Both',
  skip: 'Skip',
  repeat: 'Repeat',
  derivate: 'Derivate',
  skipCharacter: 'Make this character optional',
  repeatCharacter: 'Allow this character to repeat',
  exactCharacter: 'Keep this character exact (no family)',
  derivateWord: 'Apply derivative expansion',

  // Results
  resultsFor: 'Results for',
  matches: 'matches',
  matchSingular: 'match',
  categories: 'categories',
  categorySingular: 'category',
  all: 'All',
  noMatchesFound: 'No matches found',
  tryAdjustingSearch: 'Try adjusting your search or options',
  showMore: 'Show more',
  more: 'more',
  searching: 'Searching...',

  // Settings
  language: 'Language',
  languageDescription: 'Select your preferred language',
  theme: 'Theme',
  themeDescription: 'Toggle with the button in header',
  editTranslations: 'Edit Translations',
  editTranslationsDescription: 'Customize UI text strings',
  translationEditor: 'Translation Editor',
  searchTranslations: 'Search translations...',
  save: 'Save',
  cancel: 'Cancel',
  reset: 'Reset',
  english: 'English',
  amharic: 'Amharic',

  // Editor
  editor: 'Editor',
  newDocument: 'New Document',
  untitledDocument: 'Untitled Document',
  startTyping: 'Start typing...',
  loading: 'Loading',
  undo: 'Undo',
  redo: 'Redo',
  toggleSidebar: 'Toggle Sidebar',
  bold: 'Bold',
  italic: 'Italic',
  underline: 'Underline',
  strikethrough: 'Strikethrough',
  alignLeft: 'Align Left',
  alignCenter: 'Align Center',
  alignRight: 'Align Right',
  bulletList: 'Bullet List',
  numberedList: 'Numbered List',
  insertImage: 'Insert Image',
  insertTable: 'Insert Table',
  horizontalRule: 'Horizontal Rule',
  quote: 'Quote',
  codeBlock: 'Code Block',
  issues: 'Issues',
  statistics: 'Statistics',
  noIssuesFound: 'No issues found',
  spelling: 'Spelling',
  grammar: 'Grammar',
  fidelForm: 'Fidel Form',
  characters: 'characters',
  amharicPercent: 'Amharic',
  readingTime: 'Reading Time',
  paragraphs: 'Paragraphs',

  // Dictionary
  dictionary: 'Dictionary',
  dictionaryDescription: 'Kidane Wold Kifle Amharic Dictionary',
  searchDictionary: 'Search dictionary...',
  definition: 'Definition',
  synonyms: 'Synonyms',
  relatedWords: 'Related Words',
  examples: 'Examples',
  noResultsFound: 'No results found',
  recentLookups: 'Recent Lookups',
  startSearchingDictionary: 'Search for an Amharic word',
  selectWordToView: 'Select a word to view',
  dictionaryHint: 'Search for words or browse recent lookups to see definitions, synonyms, and related words.',
  results: 'results'
}
